import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";
import {getContent, IContentItem, IMiniGame} from "../../../../../data/data";
import HighlightText from "../../../../common/highlight-text/HighlightText";
import {getMiniGameData} from '../../../../../store/reducers/mini-game/miniGame';
import {hideModal} from '../../../../../store/actions/modals';

interface IntroProps
{
    // game_data: IMiniGame;
    // content: IContentItem;
    startGame: () => void;
    closeModal: () => void;
}

interface State
{
    countdown: number;
}

import './Intro.scss';


class Intro extends React.Component<IntroProps, State>
{
    interval: number;
    countdown_el: HTMLElement;

    constructor(public props: IntroProps, public state: State)
    {
        super(props);

        this.state = { countdown: 5 };
    }


    componentDidMount()
    {
        // console.group('componentDidMount');
        // console.log('', );
        // console.groupEnd();

        this.startCountDown();
    }


    componentWillUpdate()
    {

    }


    startCountDown = () =>
    {
        this.interval = setInterval(this.onTick, 1000) as any;
    };


    onTick = () =>
    {
        const {countdown:ocountdown} = this.state;

        const ncountdown: number = ocountdown - 1;

        if (ncountdown <= 0) return this.stopCountDown();

        this.setState({ countdown: ncountdown });

        this.countdown_el.classList.remove('bounce');

        _.delay(() => this.countdown_el.classList.add('bounce'), 50);
    };


    stopCountDown = () =>
    {
        clearInterval(this.interval);

        const {startGame, closeModal} = this.props;

        closeModal();
        startGame();
    };



    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {countdown} = this.state;

        return <div styleName={'event-intro'}>

            <p styleName={'countdown bounce'} ref={el => this.countdown_el = el}>{countdown}</p>

            {/*<div styleName={'header'}>*/}

                {/*<img*/}
                    {/*styleName={'image'}*/}
                    {/*src={`./img/game/event-details/${category}@2x.png`} />*/}

            {/*</div>*/}

            {/*<div styleName={'text-column'}>*/}

                {/*<HighlightText type={'red'}>{type}</HighlightText>*/}

                {/*<EventDetails />*/}

                {/*<h4 styleName={'headline'}>how to play</h4>*/}

                {/*<p styleName={'body-copy'}>Hit the spacebar as fast as possible to generate as much power as you can!</p>*/}

            {/*</div>*/}

        </div>;
    }
}


const mapStateToProps = state =>
{
    return {
        // game_data: getMiniGameData(state),
        // content: getContent('mini-game-intro'),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        closeModal: () => dispatch(hideModal()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Intro);



// WEBPACK FOOTER //
// ./src/ts/app/screens/mini-game/modals/intro/Intro.tsx